export const PITCH_TYPES = [
  "fastball",
  "sinker",
  "slider",
  "curveball",
  "changeup",
  "splitter",
  "cutter",
  "knuckleball",
];

export const PITCH_RESULTS = [
  { value: "ball", label: "Ball" },
  { value: "called_strike", label: "Called Strike" },
  { value: "swinging_strike", label: "Swinging Strike" },
  { value: "foul", label: "Foul" },
  { value: "strikeout_looking", label: "Strikeout Looking" },
  { value: "strikeout_swinging", label: "Strikeout Swinging" },
  { value: "in_play", label: "In Play" },
  { value: "walk", label: "Walk" },
  { value: "hit_by_pitch", label: "Hit by Pitch" },
  { value: "misc_out_1", label: "Misc. Out (1 Out)" },
  { value: "misc_out_2", label: "Misc. Out (2 Out)" },
];

export const ZONES_STANDARD = [1, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13, 14];
export const ZONES_RH = [1, 2, 3, 4, 5, 6, 7];
